// pages/SettingsPage.jsx
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import BasicInfo from "../components/settings/BasicInfo";
import NotificationSettings from "../components/settings/NotificationSettings";
import DangerZone from "../components/settings/DangerZone";
import { useTranslation } from "react-i18next"; // ← اضافه شده

const SettingsPage = () => {
  const { t, i18n } = useTranslation(); // ← اضافه شده
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    const mockUser = {
      _id: "12345",
      name: "علی نادری",
      birthdate: "1378-08-12",
      phone: "09123456789",
      email: "ali@example.com",
      avatar: "https://berrydashboard.com/free/assets/user-round-QwaXuEgi.svg",
      notificationPreferences: {
        email: true,
        sms: false,
        whatsapp: true,
      },
    };

    setUserData(mockUser);
  };

  const isRtl = i18n.language.includes("fa"); // ← برای تشخیص زبان فارسی

  // کلاس‌های Tailwind را به صورت پویا تعیین می‌کنیم
  const mainContentClass = `flex-1 flex flex-col px-2 pb-5 lg:px-0 lg:pb-0 ${
    isRtl ? "md:mr-64" : "md:ml-64"
  }`;
  const mainSectionClass = `flex-1 overflow-y-auto p-4 md:p-6 rounded-[16px] bg-gray-100 ${
    isRtl ? "lg:me-3 lg:mb-3" : "lg:ms-3 lg:mb-3"
  } space-y-8`;

  return (
    <div className="flex h-screen">
      <Helmet>
        <title>{t("settings.page_title")}</title>
      </Helmet>

      <Sidebar />
      <div className={mainContentClass}>
        <Header />
        <main className={mainSectionClass}>
          <h1 className="text-2xl font-bold text-gray-800 mb-6">
            {t("settings.page_header")}
          </h1>

          {userData && (
            <>
              <BasicInfo user={userData} />
              <NotificationSettings
                initialData={userData.notificationPreferences}
              />
              <DangerZone />
            </>
          )}
        </main>
      </div>
    </div>
  );
};

export default SettingsPage;
